<div class="fee border bg-white rounded p-3 pl-4 position-relative">
  <button
    type="button"
    class="btn btn-sm btn-circle btn-secondary-danger position-absolute"
    matTooltip="Remove Fee"
    matTooltipPosition="above"
    i18n-matTooltip
    (click)="remove.emit(true)"
    style="top: 7rem; margin-top: -2rem; left: -0.85rem; z-index: 1"
  >
    <i class="cs-icon cs-icon-trash"></i>
  </button>

  <form [formGroup]="form">
    <div class="fee_row main_row">
      <div class="col-50">
        <div class="fee_row">
          <div class="col-50 field-wrapper-mr">
            <mat-form-field2 class="name-field">
              <input
                matInput
                placeholder="Name"
                i18n-placeholder
                formControlName="name"
                [matAutocomplete]="auto"
                type="text"
                required
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  *ngFor="let category of feeCategories"
                  [value]="category"
                  [matTooltip]="category"
                  matTooltipPosition="right"
                  class="category-option"
                  >{{ category }}</mat-option
                >
              </mat-autocomplete>
              <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
                <ng-container i18n>Name is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-50 field-wrapper-ml field-wrapper-mr">
            <mat-form-field2>
              <input matInput [placeholder]="amountPlaceholder" formControlName="amount" type="number" required />
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
                <ng-container i18n>Amount is required</ng-container>
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('min')">
                <ng-container i18n>Amount must be at least 1</ng-container>
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('max')">
                <ng-container i18n>Amount must be at most 100</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
        <div class="fee_row">
          <div class="col-50 field-wrapper-mr">
            <mat-form-field2>
              <mat-select placeholder="Type" i18n-placeholder formControlName="type" required>
                <mat-option value="pct" i18n>Percent</mat-option>
                <mat-option value="flat" i18n>Flat</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')">
                <ng-container i18n>Type is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-50 field-wrapper-ml field-wrapper-mr">
            <mat-form-field2>
              <mat-select
                matTooltip="Select the modality. This determines how the fee is applied to the booking"
                matTooltipPosition="above"
                i18n-matTooltip
                placeholder="Modality"
                i18n-placeholder
                formControlName="modality"
                required
              >
                <mat-option value="ps" i18n>Per Stay</mat-option>
                <mat-option value="pn" i18n>Per Night</mat-option>
                <mat-option value="pp" i18n>Per Person</mat-option>
                <mat-option value="pppn" i18n>Per Person/Per Night (PP/PN)</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('modality').touched && form.get('modality').hasError('required')">
                <ng-container i18n>Modality is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
      </div>
      <div class="col-50 field-wrapper-ml">
        <mat-form-field2 class="mat-block">
          <textarea
            matInput
            maxlength="500"
            rows="6"
            formControlName="description"
            placeholder="Description"
            i18n-placeholder
            class="description-textarea"
            cdkTextareaAutosize
          ></textarea>
        </mat-form-field2>
      </div>
    </div>

    <!-- <button
      class="btn btn-sm btn-light-danger position-absolute"
      matTooltip="Remove Fee"
      matTooltipPosition="above"
      (click)="remove.emit(true)"
      style="top: -0.5rem; right: 0"
    >
      <i class="cs-icon cs-icon-trash"></i>
    </button> -->

    <div class="d-flex align-items-center gap-3 mb-3">
      <app-form-switch formControlName="status" [inline]="true">
        <ng-container *ngIf="form.get('status')" i18n>Active</ng-container>
        <ng-container *ngIf="!form.get('status')" i18n>Inactive</ng-container>
      </app-form-switch>
      <mat-checkbox
        matTooltip="This indicates if the fee is charged upfront"
        matTooltipPosition="above"
        i18n-matTooltip
        formControlName="upfront"
        class="upfront-control"
        i18n
      >
        Upfront
      </mat-checkbox>
      <!-- TV4-5604: Due Upon Arrival — mutually exclusive with Upfront.
           Checking one unchecks and disables the other (enforced in ngOnInit). -->
      <mat-checkbox
        matTooltip="When enabled, this fee will be collected on-site by the property manager at check-in. Mutually exclusive with Upfront."
        matTooltipPosition="above"
        i18n-matTooltip
        formControlName="due_upon_arrival"
        i18n
      >
        Due Upon Arrival
      </mat-checkbox>
      <div class="flex-fill"></div>
      <div class="show-more">
        <a *ngIf="!showDetails" (click)="showDetails = true" href="javascript:;">
          <i class="fal fa-chevron-down"></i> <ng-container i18n>More Options</ng-container>
        </a>
        <a *ngIf="showDetails" (click)="showDetails = false" href="javascript:;">
          <i class="fal fa-chevron-up"></i> <ng-container i18n>Less Options</ng-container>
        </a>
        <mat-error i18n *ngIf="!showDetails && form.get('end').touched && form.get('end').invalid && endDateInPast()">
          Scheduling End date shouldn't be in the past
        </mat-error>
        <mat-error
          *ngIf="
            !showDetails &&
            ((startCtrl.touched && startCtrl.hasError('required')) || (endCtrl.touched && endCtrl.hasError('required')))
          "
          i18n
        >
          Both scheduling start and end dates are required
        </mat-error>
      </div>
    </div>

    <div [class.hidden]="!showDetails">
      <div class="form_row">
        <mat-form-field2>
          <input
            matTooltip="This indicates if the fee applies over or under the set guest count. Use positive values to indicate over and negative to indicate under"
            matTooltipPosition="above"
            i18n-matTooltip
            matInput
            placeholder="Guest Threshold"
            i18n-placeholder
            formControlName="guest_threshold"
            type="number"
          />
        </mat-form-field2>

        <mat-form-field2>
          <input
            matTooltip="This indicates if the fee applies over or under a specific length. Use positive values to indicate over and negative to indicate under"
            matTooltipPosition="above"
            i18n-matTooltip
            matInput
            placeholder="Length Threshold"
            i18n-placeholder
            formControlName="length_threshold"
            type="number"
          />
        </mat-form-field2>

        <mat-form-field2 class="mat-calendar">
          <input
            matInput
            [matDatepicker]="startPicker"
            [max]="maxStartDate.value"
            placeholder="Scheduling Start"
            i18n-placeholder
            matTooltip="This determines on which dates the fee is applied."
            matTooltipPosition="above"
            i18n-matTooltip
            (focus)="startPicker.open()"
            formControlName="start"
            tabindex="6"
            [required]="!!endCtrl.value"
          />
          <i matSuffix (click)="startPicker.open()" class="far fa-calendar-alt"></i>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error i18n *ngIf="form.get('start').touched && form.get('start').hasError('required')">
            Scheduling Start date is required
          </mat-error>
        </mat-form-field2>

        <mat-form-field2 class="mat-calendar">
          <input
            matInput
            [matDatepicker]="endPicker"
            [min]="minEndDate.value"
            placeholder="Scheduling End"
            i18n-placeholder
            matTooltip="This determines on which dates the fee is applied."
            matTooltipPosition="above"
            i18n-matTooltip
            (focus)="endPicker.open()"
            formControlName="end"
            [required]="!!startCtrl.value"
            tabindex="6"
          />
          <i matSuffix (click)="endPicker.open()" class="far fa-calendar-alt"></i>
          <mat-datepicker #endPicker></mat-datepicker>
          <mat-error i18n *ngIf="form.get('end').touched && form.get('end').invalid && endDateInPast()">
            Scheduling End date shouldn't be in the past
          </mat-error>
          <mat-error i18n *ngIf="form.get('end').touched && form.get('end').hasError('required')">
            Scheduling End date is required
          </mat-error>
          <mat-error *ngIf="form.get('end').hasError('matDatepickerMin')">
            <ng-container i18n>Min value is</ng-container>&nbsp;
            <strong>{{ form.get('end').getError('matDatepickerMin').min | epoch : 'DD-MMM-YYYY' }}</strong>
          </mat-error>
        </mat-form-field2>
      </div>

      <div class="form_row">
        <app-select-search
          bindLabel="friendlyName"
          bindValue="id"
          [inline]="false"
          [multiple]="false"
          [items]="channels$ | async"
          [ctrl]="form.get('channel_id')"
          placeholder="Channel"
          i18n-placeholder
        ></app-select-search>

        <mat-form-field2>
          <mat-select
            matTooltip="This determines on which days the fee is applied"
            matTooltipPosition="above"
            i18n-matTooltip
            placeholder="Day of Week"
            i18n-placeholder
            formControlName="dow"
            multiple
          >
            <mat-option value="1" i18n>Monday</mat-option>
            <mat-option value="2" i18n>Tuesday</mat-option>
            <mat-option value="3" i18n>Wednesday</mat-option>
            <mat-option value="4" i18n>Thursday</mat-option>
            <mat-option value="5" i18n>Friday</mat-option>
            <mat-option value="6" i18n>Saturday</mat-option>
            <mat-option value="7" i18n>Sunday</mat-option>
          </mat-select>
        </mat-form-field2>

        <mat-checkbox
          matTooltip="This indicates if the fee is refundable"
          matTooltipPosition="above"
          i18n-matTooltip
          formControlName="refundable"
          i18n
        >
          Refundable
        </mat-checkbox>

        <mat-checkbox
          matTooltip="This indicates if the fee is taxable"
          matTooltipPosition="above"
          i18n-matTooltip
          formControlName="taxable"
          i18n
        >
          Taxable
        </mat-checkbox>
      </div>
    </div>
  </form>
</div>
